export const isErrorResponse = (response: any) => {
  return !!response.error;
};
